<template>
    <BaseDialog
            :showDialog="showSetWorksTypeDialog"
            maxDialogWidth="800"
            maxCardHeight="700"
            :scrollable="true"
            :headline="getHeadline"
            :close="closeDialog"
            :alvqa="alvqa"
        > 

        <template v-slot:dialogText>
             <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t(getConfirmationText) }}

                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col class="ma pt-0 pr-0 pb-0 " cols="4">
                        <v-text-field 
                            v-model="userInput" 
                            :messages="$t(errorMessage)" 
                            depressed
                            @keydown.enter="checkUserInput()"
                            :label="$t(getLabel)"
                            :alvqa="alvqa + '-textfield-delete'"
                        ></v-text-field>
                        <v-spacer />
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right" cols="2">
                        <BaseButton
                            @click="checkUserInput()" 
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa + '-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    
    </BaseDialog>
  
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog.vue'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "PublishingContractsWorksEditPanelSetTypeDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            userInput: '',
            errorMessage: '',
            alvqa: "to-spw-dialog",
        }
    },
    computed: {
        getHeadline() {
            if (this.getTypeOfContract() == "SLG")
                return "lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_SPW_DIALOG_TITLE"
            else 
                return "lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_OPW_DIALOG_TITLE"
        },
        showSetWorksTypeDialog: {
            get() { return this.$store.getters.getShowSetWorksTypeDialog },
            set(show) { this.$store.commit('setShowSetWorksTypeDialog', show) }
        },
        getLabel(){
            if (this.getTypeOfContract() == "SLG")
                return "lang_PUBLISHING_WORKS_DROPDOWN_TYPE_SPW"
            else 
                return "lang_PUBLISHING_WORKS_DROPDOWN_TYPE_OPW"
        },
        getConfirmationText(){
            if (this.getTypeOfContract() == "SLG")
                return "lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_SPW_CONFIRMATION"
            else 
                return "lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_OPW_CONFIRMATION"
        },
    },
    methods:{
        getTypeOfContract() { 
            return this.$store.getters.getPublishingContractsDetailsContractType
        },
        closeDialog(){
            this.$store.commit('setShowSetWorksTypeDialog',false)
            this.userInput = ''
            this.errorMessage = ''
        },
        checkUserInput() { 
            let confirmationString = this.$t(this.getLabel).toLowerCase() // can be OVW, OPW, SVW, SPW = language-aware
            let type = (confirmationString.substring(confirmationString.length - 3, 1) == "s" ? "spw" : "opw")
            if (this.userInput.toLowerCase() == confirmationString) {
                this.$store.dispatch('setWorksTypeAction', type)
                this.closeDialog()
            } else {
                this.errorMessage = 'lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_SVW_ERR_MESSAGE'
            }
        }
    }
}
</script>

<style>

</style>